let co
// Try to guess the company name (from URL)
if (process.env.NODE_ENV !== 'development' && window.location.hostname.split('.')[0]) co = window.location.hostname.split('.')[0]
else if (process.env.NODE_ENV === 'development') co = 'dev'

const initialState = {
  newTokenPromise: null,
  isAuthenticated: false,
  isRenewingToken: false,
  restrictToPunchTerminal: false,
  decodedToken: {},
  co,
  lang: 'en'
}

const auth = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IS_RENEWING_TOKEN':
      return { ...state, isRenewingToken: true, newTokenPromise: state.newTokenPromise || action.newTokenPromise }
    case 'LAUNCH_PUNCH_TERMINAL':
    case 'SET_LOGGED_IN':
      return { ...state, isAuthenticated: true, isRenewingToken: false, token: action.token, decodedToken: action.decodedToken, newTokenPromise: null }
    case 'SET_COMPANY_NAME':
      return { ...state, co: action.co }
    case 'SET_COMPANY_LANG':
      return { ...state, lang: action.lang }
    case 'SET_TRIGGER_PUNCH_OPENING':
      return { ...state, restrictToPunchTerminal: true }
    case 'CLOSE_PUNCH_TERMINAL':
    case 'SET_LOGGED_OUT':
      return { ...initialState }
    default:
      return state
  }
}

export default auth
